import { Helmet } from "react-helmet";
import Header from '../header/Header';
import HeroAyuda from './ayuda/HeroAyuda.js';
import Footer from '../footer/Footer';
import ChatAyuda from "./ayuda/ChatAyuda";
import Accordion from '../elements/accordion/Accordion';
import { accordionDataAyuda } from './ayuda/AccordionDataAyuda';

function Ayuda() {

  return (
    <>
        <Helmet>
            <meta charSet="utf-8" />
            <title>Ayuda - XDigital Neo</title>
        </Helmet>
        <Header />
        <HeroAyuda />
        <ChatAyuda />
        <Accordion accordionData={accordionDataAyuda} />
        <Footer />
    </>
  )
}

export default Ayuda